import { render, staticRenderFns } from "./titleAndDescription.vue?vue&type=template&id=3fc81f0a&scoped=true&"
import script from "./titleAndDescription.vue?vue&type=script&lang=js&"
export * from "./titleAndDescription.vue?vue&type=script&lang=js&"
import style0 from "./titleAndDescription.vue?vue&type=style&index=0&id=3fc81f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc81f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc81f0a')) {
      api.createRecord('3fc81f0a', component.options)
    } else {
      api.reload('3fc81f0a', component.options)
    }
    module.hot.accept("./titleAndDescription.vue?vue&type=template&id=3fc81f0a&scoped=true&", function () {
      api.rerender('3fc81f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/titleAndDescription.vue"
export default component.exports